<template>
  <div id="app">

    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
      <div class="container">

        <div class="navbar-brand">
          <router-link to="/" class="navbar-item glow code" style="font-size: 1.5rem">
            A Lil NANO
          </router-link>
          <router-link to="/Statistics" class="navbar-item glow code" style="font-size: 1.3rem">
            Statistics
          </router-link>
          <router-link to="/About" class="navbar-item glow code" style="font-size: 1.3rem">
            About
          </router-link>
          <a href="https://www.prizzventuresllc.com/PrivacyPolicy.txt" target="_blank" class="navbar-item glow code" style="font-size: 1.3rem">
            Privacy Policy
          </a>
          <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBurger" :class="{ 'is-active': navVisible }" @click="navVisible = !navVisible">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div id="navbarBurger" class="navbar-menu" :class="{ 'is-active': navVisible }">
          <div class="navbar-start"></div>

          <div class="navbar-end">

            <!--<div class="navbar-item">-->
              <!--<svg width="10" height="10">-->
                <!--<circle r="5px" cx="5px" cy="5px" :fill="connectionStatusColor"></circle>-->
              <!--</svg>-->
            <!--</div>-->

            <!--<div class="navbar-item">-->
              <!--{{ usersOnlineText }}-->
            <!--</div>-->


            <!--<div class="navbar-item has-dropdown is-hoverable">-->
              <!--<a class="navbar-link">-->
                <!--More-->
              <!--</a>-->

              <!--<div class="navbar-dropdown">-->
                <!--<div class="navbar-item">-->
                  <!--<div class="field">-->
                    <!--<b-checkbox v-model="shouldMockFountain">-->
                      <!--Sprinkles!!-->
                    <!--</b-checkbox>-->
                  <!--</div>-->
                <!--</div>-->

                <!--<hr class="navbar-divider">-->

                <!--<div class="navbar-item">-->
                  <!--Rendering Mode-->
                <!--</div>-->

                <!--<section>-->
                  <!--<div class="field">-->
                    <!--<b-radio v-model="renderStyle" :native-value="Style.basicStyle" class="dark-text">-->
                      <!--Basic-->
                    <!--</b-radio>-->
                  <!--</div>-->
                  <!--<div class="field">-->
                    <!--<b-radio v-model="renderStyle" :native-value="Style.shaderStyle" class="dark-text">-->
                      <!--Fancy-->
                    <!--</b-radio>-->
                  <!--</div>-->
                <!--</section>-->

              <!--</div>-->
            <!--</div>-->

            <a href="https://www.prizzventuresllc.com/" class="navbar-item" target="_blank">
              <!--<span class="icon">-->
                <!--<i class="fab fa"></i>-->
              <!--</span>-->
              <span>P Rizz</span>
            </a>
            <a href="https://twitter.com/pryszkie" class="navbar-item" target="_blank">
              <span class="icon">
                <i class="fab fa-twitter"></i>
              </span>
            </a>

          </div>

        </div>
      </div>
    </nav>

    <router-view></router-view>

    <section class="section">
      <div class="container">
        <div class="is-size-3">
          Disclaimer
        </div>
        <div class="is-size-4">
          This website utilizes advertisements to keep this service freely available to all users.
        </div>
      </div>
    </section>

    <footer class="footer is-dark" style="background-color: #111111;">
      <div class="container">

        <div class="content has-text-centered">
          <div class="columns" style="color: gray;">
            <div class="column">
              <p class="is-size-5" style="color: gray;">A Lil NANO</p>
              <p class="is-size-5" style="color: gray;">A simple faucet with random payouts for <a target="_blank" href="https://nano.org/">NANO</a></p>
              <p class="is-size-5" style="color: gray;">Made with <a href="https://vuejs.org/" target="_blank">Vue.js</a></p>
            </div>
            <div class="column">
              <p class="is-size-5" style="color: gray;">Discover the Speed of NANO from our partner, <a target="_blank" href="http://nanospeed.live">nanospeed.live</a>!</p>
              <a href="http://nanospeed.live" class="button is-success is-rounded" target="_blank">Speed Test Nano&nbsp;<span role="img" aria-label="Timer">&#9200;</span></a>
            </div>
            <div class="column">
              <p class="is-size-5">Copyright © 2019
                <a href="https://twitter.com/pryszkie" target="_blank" style="color: #167df0">
                  Peter Ryszkiewicz&nbsp;
                  <span class="icon has-text-info is-small">
                    <i class="fab fa-twitter"></i>
                  </span>
                </a>
              </p>
              <p class="is-size-5">Check out my other crypto projects at <a href="https://www.prizzventuresllc.com" target="_blank">https://www.prizzventuresllc.com</a></p>
              <a class="is-size-5" href="https://www.prizzventuresllc.com/PrivacyPolicy.txt" target="_blank">Privacy Policy</a>
            </div>
          </div>
        </div>

        <div class="has-text-centered is-size-4" style="color: gray;">
          <p>If you like these apps and want to support me making more, please consider tipping me at these addresses:</p>
          <div>
            IOTA: <code class="code-color dark-background" style="overflow-wrap: break-word;">{{ tipAddresses.IOTA }}</code>
          </div>
          <div>
            NANO: <code class="code-color dark-background" style="overflow-wrap: break-word;">{{ tipAddresses.NANO }}</code>
          </div>
          <div>
            BANANO: <code class="code-color dark-background" style="overflow-wrap: break-word;">{{ tipAddresses.BANANO }}</code>
          </div>
          <div>
            Thanks for your support!
          </div>
        </div>

      </div>
    </footer>

  </div>
</template>

<script>
import tipAddresses from 'prizz-tip-addresses'
import IOTAVsNANOContent from "./components/IOTAVsNANOContent";

export default {
  name: 'app',
  metaInfo: {
    title: 'A Lil NANO',
    meta: [
      // OpenGraph data (Most widely used)
      // {property: 'og:title', content: 'A Lil NANO - NANO Faucet'},
      // {property: 'og:site_name', content: 'A Lil NANO'},
      // // The list of types is available here: http://ogp.me/#types
      // {property: 'og:type', content: 'website'},
      // // Should the the same as your canonical link, see below.
      // {property: 'og:url', content: 'https://www.alilnano.com'},
      // {property: 'og:image', content: 'https://www.alilnano.com/a-lil-nano-reduced.png'},
      // // Often the same as your meta description, but not always.
      // {property: 'og:description', content: 'Earn A Lil NANO just by solving a captcha'},
      //
      // // Twitter card
      // {name: 'twitter:card', content: 'summary'},
      // {name: 'twitter:site', content: 'https://www.alilnano.com'},
      // {name: 'twitter:text:title', content: 'A Lil NANO'},
      // {name: 'twitter:description', content: 'Earn A Lil NANO just by solving a captcha'},
      // // Your twitter handle, if you have one.
      // {name: 'twitter:creator', content: '@pryszkie'},
      // {name: 'twitter:image', content: 'https://www.alilnano.com/a-lil-nano-reduced.png'},
      //
      // // Google / Schema.org markup:
      // {itemprop: 'name', content: 'A Lil NANO'},
      // {itemprop: 'description', content: 'Earn A Lil NANO just by solving a captcha'},
      // {itemprop: 'image', content: 'https://www.alilnano.com/a-lil-nano-reduced.png'}
    ]
  },
  components: {},
  data() {
    return {
      navVisible: false,
      tipAddresses,
      completedSessionData: null,
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 1.0s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .scale-height-enter-active, .scale-height-leave-active {
    transition: all 1.0s;
  }

  .scale-height-enter, .scale-height-leave-to {
    opacity: 0;
    max-height: 0;
  }

  .scale-height-enter-to, .scale-height-leave {
    max-height: 1000px;
  }

  .scale-up {
    transform: scale(1.2);
  }

  .ease-out-back {
    transition: all 300ms cubic-bezier(.17,.89,.26,1.76);
  }

  .dark-background {
    background-color: #080808;
  }

  .code-color{
    color: darkcyan;
  }

  .loading-overlay .loading-background {
    background-color: #080808;
  }
  .loading-overlay > div.loading-background {
    background-color: #080808;
  }

  .level-0-text {
    color: rebeccapurple;
  }
  .level-1-text {
    color: forestgreen;
  }
  .level-2-text {
    color: gold;
  }

</style>
